import React, { useEffect, useState } from 'react';
import { Grid, Paper, Typography, Button, Stack, Chip, CircularProgress } from '@mui/material';
import { useApi } from '../api/client';
import { Page } from '../components/Page';
import RefreshIcon from '@mui/icons-material/Refresh';

export default function Balances() {
  const { request } = useApi();
  const [balances, setBalances] = useState(null);
  const [loading, setLoading] = useState(true);

  async function load() {
    setLoading(true);
    try {
      const res = await request('/api/balances', { method: 'GET' });
      if (res.ok) {
        const data = await res.json();
        setBalances(data);
      }
    } catch (e) {
      console.error('Failed to load balances', e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
    const interval = setInterval(() => {
      load();
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  function formatBalance(value) {
    if (value == null || isNaN(value)) return 'N/A';
    return typeof value === 'number' ? value.toFixed(2) : value;
  }

  function getBalanceColor(balance) {
    if (balance == null || balance.error) return 'default';
    if (balance.balance > 0) return 'success';
    if (balance.balance === 0) return 'warning';
    return 'error';
  }

  if (loading && !balances) {
    return (
      <Page>
        <Paper sx={{ p: 3, textAlign: 'center' }}>
          <CircularProgress />
        </Paper>
      </Page>
    );
  }

  return (
    <Page>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper sx={{ p: 2 }}>
            <Stack direction="row" flexWrap="wrap" justifyContent="space-between" alignItems="center" gap={1} sx={{ mb: 2 }}>
              <Typography variant="h6">API Credit Balances</Typography>
              <Button onClick={load} variant="outlined" size="small" startIcon={<RefreshIcon />} disabled={loading}>
                {loading ? 'Refreshing...' : 'Refresh'}
              </Button>
            </Stack>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
              <Paper variant="outlined" sx={{ p: 2 }}>
                <Stack spacing={2}>
                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">OpenRouter</Typography>
                    {balances?.openRouter && !balances.openRouter.error && (
                      <Chip
                        label={`${formatBalance(balances.openRouter.balance)} credits`}
                        color={getBalanceColor(balances.openRouter)}
                      />
                    )}
                  </Stack>
                  {balances?.openRouter?.error ? (
                    <Typography variant="body2" color="error">
                      {balances.openRouter.error}
                    </Typography>
                  ) : balances?.openRouter ? (
                    <Stack spacing={1}>
                      <Stack direction="row" justifyContent="space-between">
                        <Typography variant="body2" color="text.secondary">
                          Total Credits:
                        </Typography>
                        <Typography variant="body2">{formatBalance(balances.openRouter.totalCredits)}</Typography>
                      </Stack>
                      <Stack direction="row" justifyContent="space-between">
                        <Typography variant="body2" color="text.secondary">
                          Total Usage:
                        </Typography>
                        <Typography variant="body2">{formatBalance(balances.openRouter.totalUsage)}</Typography>
                      </Stack>
                      <Stack direction="row" justifyContent="space-between">
                        <Typography variant="body2" color="text.secondary">
                          Balance:
                        </Typography>
                        <Typography variant="body2" fontWeight="bold">
                          {formatBalance(balances.openRouter.balance)}
                        </Typography>
                      </Stack>
                    </Stack>
                  ) : (
                    <Typography variant="body2" color="text.secondary">
                      Loading...
                    </Typography>
                  )}
                </Stack>
              </Paper>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Page>
  );
}

